import { Syllabus, SyllabusExternal } from '@/kontent/content-types'
import type { Mapping } from '@/types'
import { isRichtextElementEmpty } from '@/utils'
import { IContentItemsContainer } from '@kontent-ai/delivery-sdk'
import RichText from '../RichText'
import StatusTag from '../StatusTag'
import { Tooltip } from '../tooltip/Tooltip'
import SyllabusListShowHide from './SyllabusListShowHide'

export interface SyllabusColumnProps {
	header: string
	syllabuses: (Syllabus | SyllabusExternal)[]
	firstSyllabus?: Syllabus | SyllabusExternal | null
	tooltipElement?: any
	linkedItems: IContentItemsContainer
	mappings: Mapping[]
	isFiltered: boolean
	showMobileHeader?: boolean
	titleBlank?: string
}

function SyllabusColumn({
	header,
	syllabuses,
	tooltipElement,
	linkedItems,
	mappings,
	isFiltered,
	showMobileHeader = true,
	titleBlank = '',
}: SyllabusColumnProps) {
	const firstSyllabus = syllabuses[0]
	const status = firstSyllabus?.elements.status
	const statusYear = firstSyllabus?.elements.status_year?.value

	return (
		<div className="flex-1">
			{showMobileHeader && (
				<div className="block lg:hidden mb-2 font-bold">{header}</div>
			)}
			<div className="flex-1 flex gap-2 lg:gap-4 w-full flex-wrap lg:flex-nowrap">
				<div className="mr-auto w-full mb-4 lg:mb-0">
					<SyllabusListShowHide
						syllabuses={syllabuses}
						isActive={isFiltered}
						titleBlank={titleBlank}
					/>
				</div>
				{status && (
					<div className="flex-shrink-0">
						<StatusTag status={status} fromDate={statusYear} />
					</div>
				)}
				<div className="ml-auto lg:ml-0 w-[24px] flex-shrink-0">
					{tooltipElement &&
						!isRichtextElementEmpty(tooltipElement) && (
							<Tooltip
								iconSizeInTooltip={20}
								iconSizeInButton={24}
								text={
									<RichText
										richTextElement={tooltipElement}
										linkedItems={linkedItems}
										mappings={mappings}
									/>
								}
								disableTouchListener
							/>
						)}
				</div>
			</div>
		</div>
	)
}

export default SyllabusColumn
